export const ATTRIBUTION_LOCAL_STORAGE_KEY = 'cc_attribution'

export interface AttributionData {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  search?: string
  ad_group_id?: string
  kw?: string
  network?: string
  placement?: string
  utm_content?: string
}

export function getAttributionData(): AttributionData {
  if (typeof window === 'undefined') return {}

  const raw = localStorage.getItem(ATTRIBUTION_LOCAL_STORAGE_KEY)
  if (!raw) return {}

  return JSON.parse(raw) as AttributionData
}

export function setAttributionData(data: AttributionData) {
  if (typeof window === 'undefined') return

  localStorage.setItem(ATTRIBUTION_LOCAL_STORAGE_KEY, JSON.stringify(data))
}
